const messages = {
    sign_out: "Sign out",
    view_menu:"View menu 3",
    order_now:"Order now 5"
}
export default messages